class NumbersHelper {
  formatSimpleWithDots(value) {
    let date = value.slice(0, 10).split('-');
    return date[2] + '.' + date[1] + '.' + date[0];
  }
  getLeadingZeroDayMonth(dayMonth) {
    return (dayMonth < 10 ? '0' : '') + dayMonth;
  }
}

export default new NumbersHelper();
